'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var normalizeHtml = function normalizeHtml(html) {
  return html.replace('\n', '<br>');
};

exports.default = normalizeHtml;


// WEBPACK FOOTER //
// ./~/picidae-transformer-react-render/~/react-code-editor/lib/utils/normalizeHtml.js